export * from './DocsTextIcon';
export * from './DocsTextIcon16Light';
export * from './DocsTextIcon16Regular';
export * from './DocsTextIcon16Solid';
export * from './DocsTextIcon20Light';
export * from './DocsTextIcon20Regular';
export * from './DocsTextIcon20Solid';
export * from './DocsTextIcon24Regular';
export * from './DocsTextIcon24Solid';
export * from './DocsTextIcon32Regular';
export * from './DocsTextIcon64Regular';
